const classes = {
  OR: 'or-condition'
};

export default classes;